<template>
  <div>
    <value-or-variable v-model='value' type='number' :variables='schemaData.variables' toggle-position='col' @change='onChange' />
  </div>
</template>

<script>
import { isObject } from 'lodash';
import { abstractField } from "vue-form-generator";
import ValueOrVariable from '@ui/molecules/ValueOrVariable.vue';
export default {
  mixins: [ abstractField  ],
  data() {
    let initialValue = this.value;
    if (typeof(initialValue) === 'undefined' && typeof(this.schema.default) !== 'undefined') {
      initialValue = this.schema.default;
    } else if (typeof(initialValue) === 'undefined') {
      initialValue = 1;
    }
    if (!isObject(initialValue)) {
      initialValue = parseFloat(initialValue);
      if (initialValue !== this.value) {
        this.$set(this, 'value', initialValue);
      }
    }
    const {data} = this.vfg.schema;
    return {
      schemaData:data
    }
  },
  components:{
    ValueOrVariable
  },
  methods: {
    onChange({nv,ov}) {
      this.$emit("change", {nv,ov});
    }
  },
  computed:{
  },
  watch:{
  }
}
</script>

